var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnLendingBrowsing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76113 18.4962C7.03518 18.8068 7.50913 18.8364 7.81972 18.5624C8.13031 18.2883 8.15994 17.8144 7.88589 17.5038L6.16197 15.55H12.4999C12.9141 15.55 13.2499 15.2142 13.2499 14.8C13.2499 14.3858 12.9141 14.05 12.4999 14.05H6.16197L7.88589 12.0962C8.15994 11.7856 8.13031 11.3117 7.81972 11.0376C7.50913 10.7636 7.03518 10.7932 6.76113 11.1038L3.93762 14.3038C3.68746 14.5873 3.68746 15.0127 3.93762 15.2962L6.76113 18.4962ZM17.2387 12.8964C16.9647 13.2069 16.4907 13.2366 16.1801 12.9625C15.8695 12.6885 15.8399 12.2145 16.114 11.9039L17.8379 9.95014H11.4999C11.0857 9.95014 10.7499 9.61436 10.7499 9.20014C10.7499 8.78593 11.0857 8.45014 11.4999 8.45014H17.8379L16.114 6.49636C15.8399 6.18577 15.8695 5.71182 16.1801 5.43777C16.4907 5.16372 16.9647 5.19334 17.2387 5.50393L20.0622 8.70393C20.3124 8.98745 20.3124 9.41284 20.0622 9.69636L17.2387 12.8964Z",
    fill: "#EA7E68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLendingBrowsing);
export default __webpack_public_path__ + "static/media/icn-lending-browsing.f0e3337193f7bd7a6bf5054905ba48f1.svg";
export { ForwardRef as ReactComponent };